export default __webpack_public_path__ + "static/media/PlasticMoldingImg3.9f56e408.jpg";